module.exports = __webpack_public_path__ + "img/tty-answer.bdde03dc.svg";